import request from '@/utils/request'

// 获得浏览器版本号
export function getVersion() {
  return request({
    url: '/browser/pro/get',
    method: 'get'
  })
}

// 登录方法
export function login(username, password) {
  const data = {
    account: username,
    passwd: password
  }
  return request({
    url: '/api/portal/login',
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/api/user/getinfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
/*
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}*/

// 刷新token  /api/auth/refresh_token
export function refreshToken(refreshToken) {
  return request({
    url: '/api/auth/refresh_token?refreshToken=',
    method: 'post'
  })
}

// 获取当前XP最新版本信息
export function getXpVersion() {
  return request({
    url: '/browser/pro/get_XP',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js